<template>
  <div class="layout-wrapper">
    <v-tabs
      v-model="activeTab"
      background-color="primary"
      dark
    >
      <v-tab
       class="primary--text"
      >Billing
      </v-tab>
      <v-tab
       class="primary--text"
      >
        Pricing
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <v-row>
          <v-col :md="6" v-if="getPaymentMethod">
            <payment-info
              :paymentInformation="getPaymentMethod"
              :upcomingInvoice="getUpcomingInvoice"
            />
          </v-col>
          <v-col :md="6" v-if="getInvoices">
            <invoice
              :invoices="getInvoices"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="getLicense">
            <subscription
              :license="getLicense"
              @onUpgradeClick="handleUpgradeClick"
            />
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <pricing-list />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentInfo from '@/components/Billing/PaymentInfoNew'
import Invoice from '@/components/Billing/InvoiceNew'

export default {
  name: 'Billing',
  components: {
    'payment-info': PaymentInfo,
    invoice: Invoice,
    'pricing-list': () => import('../components/Billing/PricingList.vue'),
    subscription: () => import('../components/Billing/SubscriptionNew.vue')
  },
  computed: {
    ...mapGetters(['user', 'currentOrganization', 'billingInformation']),
    getInvoices () {
      let invoices = null
      if (this.billingInformation && this.billingInformation.invoices && Array.isArray(this.billingInformation.invoices.past) && this.billingInformation.invoices.past.length) {
        invoices = this.billingInformation.invoices.past
      }
      return invoices
    },
    getPaymentMethod () {
      let paymentMethod = null
      if (this.billingInformation && this.billingInformation.payment_method) {
        paymentMethod = this.billingInformation.payment_method
      }
      return paymentMethod
    },
    getUpcomingInvoice () {
      let invoice = null
      if (this.billingInformation && this.billingInformation.invoices && this.billingInformation.invoices.upcoming) {
        invoice = this.billingInformation.invoices.upcoming
      }
      return invoice
    },
    getLicense () {
      let license = null
      if (this.billingInformation && this.billingInformation.license) {
        license = this.billingInformation.license
      }
      return license
    }
  },
  watch: {
    'currentOrganization.entity_id' (entityId) {
      this.$store.dispatch('fetchPaymentData', entityId)
    },
    billingInformation () {
      console.log(this.billingInformation)
    }
  },
  data () {
    return {
      activeTab: null,
      PricingTab: 1
    }
  },
  methods: {
    handleUpgradeClick () {
      this.activeTab = this.PricingTab
    }
  }
}
</script>

<style scoped>

</style>
